// extracted by mini-css-extract-plugin
module.exports =  {"list":"list_iVo8BwC6"};